__turbopack_context__.v({
  "header-menu": "HeaderMenu-module-scss-module__QAAMnG__header-menu",
  "header-menu--mobile-expanded": "HeaderMenu-module-scss-module__QAAMnG__header-menu--mobile-expanded",
  "header-menu__active-region": "HeaderMenu-module-scss-module__QAAMnG__header-menu__active-region",
  "header-menu__close": "HeaderMenu-module-scss-module__QAAMnG__header-menu__close",
  "header-menu__footer": "HeaderMenu-module-scss-module__QAAMnG__header-menu__footer",
  "header-menu__footer-actions": "HeaderMenu-module-scss-module__QAAMnG__header-menu__footer-actions",
  "header-menu__footer-links": "HeaderMenu-module-scss-module__QAAMnG__header-menu__footer-links",
  "header-menu__item": "HeaderMenu-module-scss-module__QAAMnG__header-menu__item",
  "header-menu__link": "HeaderMenu-module-scss-module__QAAMnG__header-menu__link",
  "header-menu__list": "HeaderMenu-module-scss-module__QAAMnG__header-menu__list",
  "header-menu__mobile-header": "HeaderMenu-module-scss-module__QAAMnG__header-menu__mobile-header",
  "header-menu__parent": "HeaderMenu-module-scss-module__QAAMnG__header-menu__parent",
  "header-menu__parent--expanded": "HeaderMenu-module-scss-module__QAAMnG__header-menu__parent--expanded",
  "header-menu__parent-wrapper": "HeaderMenu-module-scss-module__QAAMnG__header-menu__parent-wrapper",
  "header-menu__v-bar": "HeaderMenu-module-scss-module__QAAMnG__header-menu__v-bar",
  "header-submenu": "HeaderMenu-module-scss-module__QAAMnG__header-submenu",
  "header-submenu__back": "HeaderMenu-module-scss-module__QAAMnG__header-submenu__back",
  "header-submenu__heading": "HeaderMenu-module-scss-module__QAAMnG__header-submenu__heading",
  "header-submenu__item": "HeaderMenu-module-scss-module__QAAMnG__header-submenu__item",
  "header-submenu__link": "HeaderMenu-module-scss-module__QAAMnG__header-submenu__link",
  "header-submenu__link-inner": "HeaderMenu-module-scss-module__QAAMnG__header-submenu__link-inner",
  "header-submenu__list": "HeaderMenu-module-scss-module__QAAMnG__header-submenu__list",
});
